import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import Portal from './portal/Portal'

// /area-clienti e' l'area riservata ai clienti; tutto il resto e' l'app degli operatori
const isPortal = /^\/area-clienti(\/|$)/.test(window.location.pathname)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<React.StrictMode>{isPortal ? <Portal /> : <App />}</React.StrictMode>)
